"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ImagePreview = _interopRequireDefault(require("../../Media/ImagePreview"));

var _MediaUpload = _interopRequireDefault(require("../../Media/MediaUpload"));

var _NavToolbar = _interopRequireDefault(require("../../NavToolbar/NavToolbar"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    position: "relative",
    backgroundColor: "#333",
    color: "white",
    "&:hover $preview": {
      opacity: .5
    }
  },
  action: {
    zIndex: 2,
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& > [role=group]": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }
  },
  preview: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}));

const KioskLinkMedia = ({
  formData,
  formContext,
  sidebar
}) => {
  const mediaId = formData.mediaId,
        media = formData.media,
        referenceId = formData.referenceId,
        reference = formData.reference;
  const classes = useStyles();

  const _onUpload = formContext && formContext.onUpload;

  const onDialog = formContext && formContext.onMediaDialog;
  const onChange = formContext && formContext.onMediaChange;
  const mediaButtons = [{
    icon: "remove_circle",
    label: "Remove",
    variant: "text",
    size: "small",
    onClick: () => onChange({
      mediaId: undefined,
      media: {}
    })
  }];
  const buttons = [{
    type: "upload",
    label: "Upload",
    size: "small",
    onUpload: acceptedFiles => _onUpload({
      acceptedFiles
    })
  }, {
    icon: "search",
    label: "Finn media",
    variant: "text",
    size: "small",
    onClick: () => onDialog(sidebar.query)
  }];
  const buttonGroupProps = {
    "alignItems": "center",
    "flexDirection": "column"
  };
  const imageUrl = mediaId && media && media.imageUrl || referenceId && reference && reference.imageUrl;

  if (media && media.imageUrl) {
    return _react.default.createElement("figure", {
      className: classes.root,
      "data-name": "media"
    }, _react.default.createElement(_ImagePreview.default, {
      className: classes.preview,
      imageUrl: media.imageUrl
    }), _react.default.createElement(_MediaUpload.default, {
      className: classes.action,
      mediaType: "image",
      buttonGroupProps: buttonGroupProps,
      buttons: mediaButtons
    }));
  }

  if (referenceId && reference && reference.imageUrl) {
    return _react.default.createElement("figure", {
      className: classes.root,
      "data-name": "media"
    }, _react.default.createElement(_ImagePreview.default, {
      className: classes.preview,
      imageUrl: reference.imageUrl
    }), _react.default.createElement(_MediaUpload.default, {
      className: classes.action,
      mediaType: "image",
      buttonGroupProps: buttonGroupProps,
      buttons: buttons
    }));
  }

  return _react.default.createElement("figure", {
    className: classes.root,
    "data-name": "media"
  }, _react.default.createElement(_MediaUpload.default, {
    className: classes.action,
    mediaType: "image",
    buttonGroupProps: buttonGroupProps,
    buttons: buttons
  }));
};

var _default = KioskLinkMedia;
exports.default = _default;
module.exports = exports.default;